import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { Numeric } from "../primitives/Numeric.js";
import { formatGBP } from "../utils/format.js";
export function VolumeBreakList({ breaks, currentQty = 0, className }) {
    const sorted = [...breaks].sort((a, b) => a.fromQty - b.fromQty);
    const activeIdx = sorted.reduce((acc, b, i) => (currentQty >= b.fromQty ? i : acc), -1);
    return (_jsx("ul", { "data-slot": "volume-breaks", className: cn("flex flex-col divide-y divide-ink-100 rounded-sm border border-ink-200 bg-ivory", className), children: sorted.map((b, i) => {
            const next = sorted[i + 1];
            const ceiling = next ? next.fromQty : null;
            const active = i === activeIdx;
            const progress = active && ceiling
                ? Math.min(1, (currentQty - b.fromQty) / (ceiling - b.fromQty))
                : active
                    ? 1
                    : 0;
            return (_jsxs("li", { "data-slot": "volume-break", "data-active": active ? "true" : undefined, className: cn("relative flex items-center justify-between px-4 py-3", active && "bg-accent-soft"), children: [_jsxs("span", { className: "text-body text-ink-700", children: [_jsxs(Numeric, { children: [b.fromQty, "+"] }), " units"] }), _jsx(Numeric, { serif: true, className: "text-title-md text-ink-900", children: formatGBP(b.unitAmountMinor) }), active ? (_jsx("span", { "aria-hidden": true, className: "absolute inset-x-0 bottom-0 h-px bg-accent transition-transform duration-fast ease-out", 
                        // physical: intentional — scaleX origin sweeps from the visual
                        // left; CSS transform-origin has no logical keyword. Cosmetic
                        // LTR sweep in RTL (flag for F1 visual check).
                        style: { transform: `scaleX(${progress})`, transformOrigin: "left" } })) : null] }, b.fromQty));
        }) }));
}
